<template>
  <div>
    <!-- {{ data_object }} -->
    <!-- resourceVBind:{{ resourceVBind }} -->
    <!-- calModel:{{ calModel }} -->
    <v-toolbar flat>
      <v-tabs v-model="activeTab" align-with-title show-arrows>
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab
          ><v-icon color="warning" class="ma-2">mdi-calendar</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">{{
            calTabTitle || "Calendar"
          }}</span></v-tab
        >
        <v-tab v-show="tableReady"
          ><v-icon class="ma-2">mdi-table</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">{{
            tableTabTitle || "Table"
          }}</span></v-tab
        >
        <v-tab v-show="mapReady && (dayClicked || eventClicked)"
          ><v-icon color="success" class="ma-2">mdi-map</v-icon>
          <span color="success" v-if="$vuetify.breakpoint.mdAndUp">
            {{ mapLoading ? mapTitle + " loading" : mapTitle }}
          </span>
          <span v-else>
            {{ mapLoading ? " loading" : "" }}
          </span>
          <v-btn v-if="mapLoading" text :loading="true"></v-btn>
        </v-tab>
        <v-tab
          v-show="
            dayClicked &&
              resourceVBind &&
              resourceReady &&
              !resourceInsteadOfTable
          "
          ><v-icon color="success" class="ma-2">mdi-chart-timeline</v-icon>
          <span
            color="success"
            v-if="$vuetify.breakpoint.mdAndUp && resourceVBind"
          >
            {{ resourceVBind.resourceName }}
          </span>
        </v-tab>
      </v-tabs>
      <h5 class="ma-4 current-date">{{ currentDate }}</h5>
      <!-- <v-spacer></v-spacer> -->

      <v-toolbar flat v-if="!loading" key="toolBarKey">
        <!--  -->

        <v-date-field
          :key="calModelKey"
          class="ma-4"
          style="width:300px"
          v-model="calModel"
          @dateFieldClicked="dateFieldClicked"
        ></v-date-field>

        <div v-for="(c, i) in calToolBarControls" :key="i">
          <v-btn
            :hidden="c.hidden"
            class="ma-2"
            :color="c['v-bind'].color"
            :text="c['v-bind'].text"
            v-if="c.comp == 'v-btn' && !c.hidden && c.show"
            @click="customBtnClick(c.id)"
            :loading="customBtnLoading"
          >
            <v-icon v-if="c['v-bind'].icon">
              {{ c["v-bind"].icon }}
            </v-icon>
            {{ c["v-bind"]["input-value"] }}
          </v-btn>

          <component
            v-if="c.comp != 'v-btn' && !c.hidden && c.show"
            :hidden="c.hidden"
            small
            class="ma-2"
            :is="c[`comp`]"
            :ref="c[`id`]"
            :id="c[`id`]"
            :key="c[`key`]"
            v-bind="c[`v-bind`]"
          />
        </div>
      </v-toolbar>

      <v-btn v-if="!activeTab" @click="refresh()" text>
        <v-icon class="ma-2">mdi-reload</v-icon>
        <div v-if="$vuetify.breakpoint.mdAndUp">Refresh</div>
      </v-btn>
    </v-toolbar>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-data-calendar
          :calModel="calModel"
          :onDateChanged="onDateChanged"
          :eventTemplate="eventTemplate"
          :curDate="curDate"
          :data-object="data_object"
          :getQry="getQry"
          :getEventColor="getEventColor"
          :key="calKey"
          :eventClick="doEventClick"
          :dayClick="dayClick"
          :calHeight="calendarHeight"
          :defaultType="defaultType"
          :eventType="eventType"
          :dateType="dateType"
          :onDataReceived="initData"
          :filter="calendarFilter"
          :summaryTemplate="summaryTemplate"
          ref="calendar"
          :categoryTemplate="categoryTemplate"
          :categoryName="categoryName"
          :categoryDays="categoryDays"
          :eventHeight="eventHeight"
          :showMore="showMore"
          :tableName="tableName"
        ></v-data-calendar>
      </v-tab-item>
      <v-tab-item>
        <div v-if="tableLoading">
          <v-skeleton-loader
            class="mx-auto"
            :tile="true"
            max-width="90%"
            type="heading,table-tbody"
            !
            loading-text="Loading Table..."
          ></v-skeleton-loader>
        </div>
        <!-- {{ filterTabs }} -->

        <d-table
          v-if="
            data_object &&
              tableReady &&
              activeTab &&
              !tableLoading &&
              !resourceInsteadOfTable
          "
          :expansionColumns="expansionColumns"
          :noRefreshButton="true"
          :hideAllTabFilter="hideAllTabFilter"
          :data_object="data_object"
          :noEditDialogButtons="noEditDialogButtons"
          :getFreshData="getFreshData"
          :table_title="tableTitle"
          :linkClick="linkClick"
          :link="link"
          :directEdit="false"
          :allEditable="allEditable"
          :editable="editable"
          :onDataReceived="onDataReceived"
          :coloredFields="coloredFields"
          :getItemColor="getItemColor"
          :itemsPerPage="itemsPerPage"
          :searchableColumns="searchableColumns"
          ref="dTable"
          :noDelete="noDelete"
          :key="tableKey"
          :alwaysUpdate="alwaysUpdate"
          :groupName="groupName"
          :defaultTabCaption="defaultTabCaption"
          :filterTabs="filterTabs"
          :filterTabsFn="filterTabsFn"
          :filterCondition="filterCondition"
          :editRow="editRow"
          :addButtonCaption="addButtonCaption"
          :fields_excluded="fieldsExcluded"
          :disabledProperty="disabledProperty"
          :getRowClass="getRowClass"
          :afterSave="afterSave"
          :tableName="tableName"
          :isDraggable="tableDraggable"
          :onRowDragDrop="onRowDragDrop"
          :sortBy="sortBy || 'date'"
          :customSort="customSort"
          :customSortItems="customSortItems"
          :customFilter="customFilter"
          :toolBarControls="toolBarControls"
          :toolbarRight="true"
          :hasSearch="true"
          :groupBy="groupBy"
          :showGroupBy="showGroupBy"
          :singleSelect="singleSelect"
          :editData="tableData"
          :hasAdvancedSearch="hasAdvancedSearch"
          v-bind="tVbind"
          :editedItemTitle="editedItemTitle"
          :selectSwitch="selectSwitch"
          :columnTool="true"
          :actionCommand="actionCommand"
          :columns="columns"
        />
        <v-resource-scheduler
          v-if="resourceInsteadOfTable"
          :linkClick="linkClick"
          :dataTemplate="dataTemplate"
          v-bind="resourceVBind"
          ref="resource"
          :key="resourceKey"
        ></v-resource-scheduler>
      </v-tab-item>
      <v-tab-item>
        <div>
          <v-here-map
            :key="mapKey"
            :onMarkerClick="onMarkerClick"
            :onMarkerDrop="onMarkerDrop"
            :topElementClick="topElementClick"
            :mapHeight="mapHeight - 250"
            :mapData="mapData"
            :legend="mapLegend"
            :onLegendSelection="onLegendSelection"
            ref="hereMap"
            :routing="$route.params.id"
            :loading="mapLoading"
            :refresh="mapRefresh"
            :mapWidth="mapWidth"
          ></v-here-map>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-resource-scheduler
          :linkClick="linkClick"
          :dataTemplate="dataTemplate"
          v-bind="resourceVBind"
          ref="resource"
          :key="resourceKey"
        ></v-resource-scheduler>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import { fa } from "vuetify/lib/locale";
export default {
  name: "CalTblMap",
  components: {
    DTable: () => import("../components/Table.vue"),
    VDataCalendar: () => import("../components/DataCalendar.vue"),
    VHereMap: () => import("../components/HereMap.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VLoader: () => import("./UI/Loader.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VResourceScheduler: () => import("../components/ResourceScheduler.vue"),
    VDateField: () => import("./DateField.vue"),
  },
  props: {
    eventTemplate: Function,
    summaryTemplate: Function,
    curDate: String,
    selectSwitch: Boolean,
    // data_object: Object,
    // getQry: Function,
    // getEventColor: Function,
    eventClick: Function,
    // dayClick: Function,
    eventType: String,
    dateType: String,
    onDataReceived: Function,
    filter: String,
    // tableReady: Boolean,
    // calendarReady: Boolean,
    calendarFilter: Function,
    tableTitle: String,
    linkClick: Function,
    link: [String, Object],
    editable: Boolean,
    coloredFields: Array,
    getItemColor: Function,
    searchableColumns: Array,
    noDelete: Boolean,
    alwaysUpdate: Boolean,
    groupName: String,
    showGroupBy: Boolean,
    filterTabs: String,
    filterCondition: String,
    editRow: Boolean,
    addButtonCaption: String,
    fieldsExcluded: Array,
    disabledProperty: String,
    getRowClass: Function,
    afterSave: Function,
    tableName: String,
    isDraggable: Boolean,
    onRowDragDrop: Function,
    sortBy: String,
    customSort: Function,
    customSortItems: String,
    customFilter: Function,
    toolBarControls: Array,
    groupBy: String,
    singleSelect: Boolean,
    mapKey: Number,
    // calKey: Number,
    // tableKey: Number,
    // mapReady: Boolean,
    onMarkerClick: Function,
    onMarkerDrop: Function,
    topElementClick: Function,
    // mapHeight: [String, Number],
    // mapWidth: [String, Number],
    mapData: Array,
    mapTitle: String,
    mapLegend: Object,
    onLegendSelection: Function,
    reload: Function,
    tableDraggable: Boolean,
    activeTabChanged: Function,
    dateField: String,
    getDataObject: Function,
    defaultEventColor: String,
    updateTable: Function,
    hasAdvancedSearch: Boolean,
    mapRefresh: Number,
    createRouteData: Function,
    defaultTab: Number,
    noEditDialogButtons: Boolean,
    allEditable: Boolean,
    filterItems: Array,
    noTabs: Boolean,
    hideAllTabFilter: Boolean,
    calHeight: String,
    getTable: Function,
    tblVBind: Object,
    editedItemTitle: Array,
    filterTabsFn: String,
    calToolBarControls: Array,
    itemsPerPage: Number,
    showFullTable: Boolean,
    actionCommand: Array,
    resourceVBind: Object,
    dayClickFilter: Function,
    defaultTabCaption: String,
    defaultType: String,
    dataTemplate: Function,
    customDayClick: Function,
    categoryTemplate: String,
    categoryName: String,
    categoryDays: Number,
    eventHeight: Number,
    resourceInsteadOfTable: Boolean,
    calTabTitle: String,
    tableTabTitle: String,
    showMore: Boolean,
    expansionColumns: Number,
  },
  data() {
    return {
      activeTab: 0,
      mapReady: false,
      mapLoading: false,
      data_object: {},
      calendarReady: true,
      mapHeight: 0,
      contWidth: 0,
      mapWidth: 0,
      cal: null,
      dataCal: null,
      calKey: 0,
      calModelKey: 0,
      calModel: null,
      calLoading: false,
      tableKey: 0,
      tableReady: false,
      tableData: [],
      model: [],
      tableHeaders: [],
      columns: [],
      dataObject: {},
      calendarHeight: "67vh",
      dayClicked: false,
      eventClicked: false,
      getFreshData: false,
      tableLoading: false,
      loadingText: "Data loading",
      loadingElements: [document.getElementsByClassName("v-data-table")[0]],
      tVBind: null,
      resourceReady: false,
      currentDate: "",
      d: "",
      resourceKey: 0,
      toolBarKey: 0,
      calType: "",
      calendarChanged: false,
      // mapLegend: null,
    };
  },
  mounted() {
    var that = this;

    this.mapHeight = window.innerHeight - 80;
    try {
      this.contWidth =
        window.innerWidth -
        document.getElementsByClassName("left-menu")[0].offsetWidth -
        40;
    } catch (error) {
      //
    }

    this.mapWidth = window.innerWidth * 0.8;
    if (this.calHeight) {
      this.calendarHeight = this.calHeight;
    }
    this.$root.$on("tableItemChanged", (t) => {
      if (t.tbl.tableName == that.tableName) {
        that.updateTable(t);
      }
    });
    this.activeTab = this.defaultTab || 0;
  },
  // activated() {
  //   this.refresh();
  // },
  beforeDestroy() {},
  methods: {
    dateFieldClicked() {
      this.calendarChanged = true;
    },
    onDateChanged(d) {
      this.calModel = d;
      // this.calModelKey = !this.calModelKey;
    },
    doEventClick(e) {
      this.eventClicked = true;
      this.eventClick(e, this);
    },
    initData(data, f, showTable, fromScroll) {
      var cal = this.$refs.calendar;
      this.calLoading = cal.loading;
      this.calType = cal.type;
      if (this.activeTab) {
        this.dataObject = data;
        this.model = data.model;
        this.data_object.headers = data.headers;
        this.data_object.schema = data.schema;
        this.tVbind = this.tblVBind || data.schema["v-bind"];
        this.tableData = fun.clone(this.model);
        // if (this.tableData.length) {
        //   if (this.activeTap != 1) {
        //     this.tableReady = this.showFullTable;
        //   }
        // }
      }
      if (this.calToolBarControls) {
        this.calToolBarControls.forEach((c) => {
          if (!c.types || (c.types && c.types.includes(this.calType))) {
            c.show = true;
          } else {
            c.show = false;
          }
        });
      }

      if (this.onDataReceived) {
        if (this.defaultTab) {
          this.activeTab = this.defaultTab;
          // if (this.tableData.length) {
          this.tableKey = !this.tableKey;
          this.tableReady = this.showFullTable;
          this.mapReady = true;
          // }

          this.onDataReceived(data, null, (r) => {
            this.tableData = r;
            this.tableKey = !this.tableKey;
            this.tableReady = this.showFullTable;
            this.mapReady = true;
          });
        } else {
          if (this.tableData.additional_model) {
            this.columns = this.tableData.additional_model.columns;
          }

          var returnData = this.onDataReceived(
            data,
            f,
            this.cal.type,
            showTable,
            fromScroll
          );
          if (returnData) {
            this.tableData = returnData;
          }

          // if (this.activeTab) {
          this.tableKey = !this.tableKey;
          // }

          if (f) {
            console.log;
          }
          // this.tableData = data.model;
        }
      }
      return returnData;
    },
    getEventColor(event) {
      return event.color || this.defaultEventColor;
    },
    refresh(d) {
      // this.getQry();
      this.calKey = !this.calKey;
      // this.$ref.calendar.calKey = !this.$ref.calendar.calKey;

      if (d && d.item && this.tableData) {
        this.tableData.filter((t) => {
          return t._id == d.item._id;
        })[0] = d.item;
        this.tableKey = !this.tableKey;
      } else {
        this.tableKey = !this.tableKey;
      }
    },
    refreshTable() {
      this.tableKey = !this.tableKey;
    },
    showFilteredTable() {
      this.tableData = fun.clone(this.model);
      // var dateField = this.data_object.date_fields[0];
      if (this.onDataReceived) {
        this.tableData = this.onDataReceived(this.dataObject);
        // this.tableData = this.tableData.filter((t) => {
        //   return (
        //     new Date(t[dateField]) >= startDate &&
        //     new Date(t[dateField]) <= endDate
        //   );
        // });
      }
      // if (!dontChangeTab) {
      //   this.activeTab = 1;
      // }

      this.tableReady = true;
      this.tableKey = !this.tableKey;
    },
    dayClick(d, dontChangeTab, tableData) {
      console.log(d);
      this.calModel = d;
      if (!tableData) {
        this.currentDate = fun.formatFullDate(d);
        this.d = d;
        this.mapData = [];
        var startDate = new Date(d);
        startDate.setHours(0, 0, 0, 0);
        var endDate = new Date(fun.clone(startDate));
        endDate = new Date(endDate.setDate(startDate.getDate() + 1));

        this.getQry(d, d, null, true);

        var dateField = this.data_object.date_fields[0];
        if (this.onDataReceived) {
          this.tableData = this.onDataReceived(this.dataObject, startDate);
          this.tableData = this.tableData.filter((t) => {
            return (
              new Date(t[dateField]) >= startDate &&
              new Date(t[dateField]) <= endDate
            );
          });
          // if (this.dayClickFilter) {
          //   this.dayClickFilter();
          // }
        } else {
          this.tableData = fun.clone(this.model);
        }
        if (!dontChangeTab) {
          this.activeTab = 1;
        }

        this.tableReady = true;
        this.tableKey = !this.tableKey;

        if (this.createRouteData) {
          var dayQry = fun.clone(this.data_object.qry);
          dayQry[this.dateField] = {
            // date: {
            $gte: fun.formatDate(startDate, true),
            $lte: fun.formatDate(endDate, true),
            // },
          };
          this.createRouteData(dayQry, this.tableData);
        }
        this.mapReady = true;
        this.dayClicked = true;
        this.resourceKey = !this.resourceKey;
      } else {
        //
        if (tableData.model) {
          this.tableData = tableData.model;
        } else {
          this.tableData = tableData;
        }

        // this.tableData.model = tableData;
        this.activeTab = 1;
        this.tableReady = true;
        this.tableKey = !this.tableKey;
        this.dayClicked = true;
      }
      if (this.customDayClick) {
        var cont = this.customDayClick(d, this);
        if (!cont) {
          return;
        }
      }
      //  this.mapData.length;
    },
    convertToMongoISODate(dateFilter) {
      // Convert string dates to ISODate format
      let convertedFilter = {
        $gte: `ISODate("${dateFilter.$gte}T00:00:00.000Z")`,
        $lt: `ISODate("${dateFilter.$lt}T00:00:00.000Z")`,
      };

      return { date: convertedFilter };
    },
    getQry(s, e, tbl, daily, dateFrame) {
      this.cal = this.$refs.calendar.$refs.calendar;
      if (!this.cal) {
        return;
      }

      // if (!this.data_object.schema || daily) {
      var data_object = this.getDataObject(
        tbl,
        this.cal.type,
        daily,
        dateFrame
      );

      if (!this.data_object) {
        return;
      }
      if (data_object && !data_object.schema) {
        data_object.schema = this.data_object.schema;
      }
      this.data_object = data_object;
      // }

      if (!this.data_object.qry) {
        this.data_object.qry = {};
      }
      var end = new Date(e).addDays(1);
      try {
        if (this.dateField && s && e) {
          this.data_object.qry[this.dateField] = {
            // date: {
            $gte: fun.formatDate(new Date(s), true),
            $lt: fun.formatDate(end, true),
            // },
          };
          if (this.data_object.qry_to_match) {
            var mongoQry = this.convertToMongoISODate(
              this.data_object.qry[this.dateField]
            );
            this.data_object.qry_to_match = mongoQry;
          }
          if (!this.data_object.dateQry) {
            this.data_object.dateQry = {};
          }

          this.data_object.dateQry[this.dateField] = this.data_object.qry[
            this.dateField
          ];
        }
      } catch (error) {
        //
      }

      return this.data_object;
    },
  },
  computed: {
    tblStyle() {
      var width = screen.width - 10;
      if (this.$vuetify.breakpoint.smAndDown) {
        return "width:" + width + "px; overflow:auto";
      } else {
        return "";
      }
    },
  },
  watch: {
    calLoading() {
      if (this.$refs.resource) {
        this.$refs.resource.loading = this.calLoading;
      }

      // console.log("calendar loading", this.calLoading);
    },
    calModel() {
      // this.$nextTick(() => {
      this.dataCal = this.$refs.calendar;
      // this.dataCal.calModel = this.calModel;
      // });
      const dateCompare =
        this.calModel &&
        this.dataCal.model &&
        fun.formatDate(this.calModel) != fun.formatDate(this.dataCal.model);
      if (dateCompare) {
        this.dataCal.model = this.calModel;
        if (!this.dataCal.refresh) {
          this.dataCal.refresh = true;
        }
        if (this.activeTab && this.calendarChanged) {
          this.calendarChanged = false;
          if (this.$refs.resource) {
            this.$refs.resource.loading = true;
          }
          this.customDayClick(this.calModel);
        }
      }
    },
    activeTab() {
      // this.$root.$emit("calTabChanged", this);
      this.$refs.calendar.calTabChanged(this.activeTab);
      if (this.currentDate && this.resourceVBind) {
        this.resourceVBind.date = this.currentDate;
        this.resourceVBind.d = this.d;
        // this.resourceVBind.calModel = this.calModel;
        // this.resourceVBind.onDateChanged = this.onDateChanged;
      }
      this.resourceReady = true;
      if (!this.activeTab) {
        this.currentDate = "";
      }

      var that = this;
      if (!this.dayClicked && !this.eventClicked && this.showFullTable) {
        // this.tableReady = false;
        this.showFilteredTable();
        // this.loading = true;
        // that.tableData = [];
        // that.tableLoading = true;
        // var dataObj = this.getDataObject();
        // dataObj.getTable = "all";
        // axios
        //   .post(this.serverURL + "/get_data", dataObj, {
        //     withCredentials: true,
        //   })
        //   .then((response) => {
        //     that.tableLoading = false;
        //     this.loading = false;
        //     this.dayClicked = false;
        //     this.eventClicked = false;
        //     that.tableData = response.data.model;
        //     if (this.onDataReceived) {
        //       that.tableData = this.onDataReceived(response.data);
        //     }
        //     // that.$refs.dTable.selected = [];
        //     this.singleSelect = false;
        //     this.tableReady = true;
        //     this.tableKey = !this.tableKey;
        //   });
        // // this.getFreshData = true;
        // // this.data_object.qry = {};
        // // this.tableKey = !this.tableKey;
      } else {
        if (!this.activeTab && !this.defaultTab) {
          // if (this.activeTab != 1) {
          //   this.tableReady = this.showFullTable;
          // }

          this.mapReady = false;
          this.resourceReady = false;
        }
        if (this.activeTabChanged) {
          this.activeTabChanged(this.activeTab);
        }
        if (this.activeTab == 1) {
          if (this.tableData) {
            // this.tableData=this.onDataReceived
          }
        }
      }
      // this.dayClicked = false;
      // this.eventClicked = false;
    },
  },
};
</script>

<style lang="css" scoped>
.current-date {
  white-space: nowrap;
}
</style>
